/* import __COLOCATED_TEMPLATE__ from './translation-toggle.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';
import type { Channel } from 'embercom/models/data/inbox/channels';

interface Args {
  language: string;
  onToggle: () => void;
  seen?: boolean;
  showOriginalMessage?: boolean;
  author?: 'user' | 'teammate';
  current_channel?: Channel;
}

export default class TranslationToggle extends Component<Args> {
  @service declare intl: IntlService;
  @service declare intercomEventService: $TSFixMe;

  place = 'conversation_stream';

  get translationLabel() {
    if (this.args.seen) {
      return this.intl.t('inbox.conversation-stream.seen-in', { language: this.args.language });
    }
    return this.intl.t('inbox.conversation-stream.sent-in', { language: this.args.language });
  }

  @action
  handleToggle() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'toggle_translation',
      place: this.place,
      context: 'conversation_part',
      metadata: {
        translation_language: this.args.language,
        show_original_message: !this.args.showOriginalMessage,
        author: this.args.author,
        message_channel: this.args.current_channel,
      },
    });

    this.args.onToggle();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::Parts::TranslationToggle': typeof TranslationToggle;
  }
}
